/**
 * PROJECT-SEND-SMS.MODAL
 * Send an sms invitation to participation
 */

import { withTranslation, WithTranslation } from "react-i18next"
import { connect } from "react-redux"
import { ProjectState } from "@/redux/project.types"
import { InvitationState } from "@/redux/invitation.types"
import ModalConfirm from "@/components/modal-confirm"
import { store } from ".."
import { projectStatus } from "@/redux/project.actions"
import { STATUS_SAVED, STATUS_SAVING } from "@/redux/_status.types"
import { toast } from "react-toastify"
import { invitationSendSms } from "@/redux/invitation.actions"

interface StateProps extends WithTranslation {
  invitation: InvitationState
  project: ProjectState
}

interface OwnProps {
  onClose: Function
}

type Props = StateProps & OwnProps

function ProjectSendSmsModal(props: Props) {
  const { t } = props

  //Next
  async function next() {
    store.dispatch(projectStatus(STATUS_SAVING))
    const response: any = await store.dispatch(invitationSendSms(props.project.active.id, props.invitation.active.aid))
    if (!response.error)
      toast(
        t("invitation_send_sms_confirm", {
          phone: props.invitation.active.phone,
          name: props.invitation.active.username
        })
      )
    store.dispatch(projectStatus(STATUS_SAVED))
    props.onClose()
  }

  return (
    <ModalConfirm
      onYes={() => next()}
      onNo={() => props.onClose()}
      textBold={t("utils_next_ask")}
      text={t("invitation_send_sms_help", {
        phone: props.invitation.active.phone,
        name: props.invitation.active.username
      })}
    />
  )
}

const mapStateToProps = (state) => ({
  invitation: state.invitation,
  project: state.project
})

export default connect(mapStateToProps)(withTranslation()(ProjectSendSmsModal))
